import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_MESSAGE_CIRCLE_MORE: GlameraIconDefinition = {
  name: 'message-circle-more',
  viewBox: '0 0 24 24',
  svg: `
    <g class="glm-message-circle-more-bubble">
      <path d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719"></path>
      <path class="glm-message-circle-more-dot glm-message-circle-more-dot-1" d="M8 12h.01"></path>
      <path class="glm-message-circle-more-dot glm-message-circle-more-dot-2" d="M12 12h.01"></path>
      <path class="glm-message-circle-more-dot glm-message-circle-more-dot-3" d="M16 12h.01"></path>
    </g>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-message-circle-more-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './message-circle-more.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class MessageCircleMoreIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_MESSAGE_CIRCLE_MORE;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
